import { GraphQLClient } from 'graphql-request';

import appConfig from '../../common/config';

const baseClient = new GraphQLClient(appConfig.common.backendGraphQLUrl);
const dzmsClient = new GraphQLClient(appConfig.common.dzmsGraphQLUrl);
const verdClient = new GraphQLClient(appConfig.common.verdGraphQLUrl);

export default { baseClient, dzmsClient, verdClient };
